const { instance } = require('./url')

async function getAccounts() {
    return await instance.get('/admin/accounts')
}

async function updateAccount(id, fields) {
    return await instance.put('/admin/accounts/' + id, {
        'account': fields,
    })
}

async function deleteAccount(id) {
    return await instance.delete('/admin/accounts/' + id)
}

export {
    getAccounts,
    updateAccount,
    deleteAccount,
}

